import {
  EventReportEventableTypeEnum,
  EventReportGroupableTypeEnum,
  EventReportTypeEnum,
  EventReportVisibilityEnum,
} from '../_generated/openapi';

export const EventReportEventableType = {
  BASKETBALL_CLUB_GAME:
    'App\\Models\\Basketball\\BasketballClubGame' as EventReportEventableTypeEnum,
  BASKETBALL_TEAM_GAME:
    'App\\Models\\Basketball\\BasketballTeamGame' as EventReportEventableTypeEnum,
};

export const EventReportGroupableType = {
  CLUB: 'App\\Models\\Base\\Club' as EventReportGroupableTypeEnum,
  BASKETBALL_TEAM:
    'App\\Models\\Basketball\\BasketballTeam' as EventReportGroupableTypeEnum,
};

export const EventReportVisibility = {
  PUBLIC: 'public' as EventReportVisibilityEnum,
  PRIVATE: 'private' as EventReportVisibilityEnum,
};

export const EventReportType = {
  PRE: 'pre' as EventReportTypeEnum,
  POST: 'post' as EventReportTypeEnum,
};
